import Intro from './Intro/'
import About from './About/'
import Share from './Share/'
import FindAGrove from './FindAGrove/'
import DedicateAGrove from './DedicateAGrove/'

const routes = [
  {
    path: '/',
    component: <Intro />,
    label: 'Intro',
  },
  {
    path: '/find-a-grove/',
    link: '/find-a-grove',
    component: <FindAGrove />,
    label: 'Find a Grove',
  },
  {
    path: '/find-a-grove/:slug',
    link: '/find-a-grove',
    component: <FindAGrove />,
  },

  {
    path: '/find-a-grove/park/:parkId',
    link: '/find-a-grove',
    component: <FindAGrove />,
  },
  {
    path: '/dedicate-a-grove',
    component: <DedicateAGrove />,
    label: 'Dedicate a Grove',
  },
  {
    path: '/about',
    component: <About />,
    label: 'About',
    modal: true,
  },
  {
    link: 'https://secure.savetheredwoods.org/a/donate',
    label: 'DONATE',
    component: null,
  }

]

export default routes
